import { Form } from "antd";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

type CheckOutFieldContentProps = {
  className?: string;
  getValueProps?: (value: any) => { value: any };
  children: ReactNode;
};

const CheckOutFieldContent: FC<CheckOutFieldContentProps> = ({ className, getValueProps, children }) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="checkout"
      dependencies={["checkin"]}
      className={className}
      getValueProps={getValueProps}
      rules={[
        { required: true, message: t("Hotels.search.checkoutRequired") },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const checkinValue = getFieldValue("checkin");
            if (!value || !checkinValue) return Promise.resolve();
            if (!value.isAfter(checkinValue, "day")) {
              return Promise.reject(new Error(t("Hotels.search.checkoutAfterCheckin")));
            }
            if (value.isAfter(checkinValue.add(1, "month"), "day")) {
              return Promise.reject(new Error(t("Hotels.search.checkoutWithinOneMonth")));
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      {children}
    </Form.Item>
  );
};

export default CheckOutFieldContent;
